/**
 * 推荐中介
 * 
 * @Author: Focci
 * @Date: 2023-10-09 15:39:56
 * @Last Modified by: Focci
 * @Last Modified time: 2023-10-09 15:39:56
 */

'use client'

import PropTypes from 'prop-types'
import useFetch from '@hook/useFetch'
import useDialog from '@hook/useDialog'
import clsx from 'clsx'
import { useCallback, useMemo, useState } from 'react'
import { useTranslations } from 'next-intl'
import { Waypoint } from 'react-waypoint'
import { isArray } from 'lodash-es'
import PromoteAgentCard from './PromoteAgentCard'
import MailConsultingAgency from '../floating-agent/MailConsultingAgency'

export default function PromoteAgents({ house }) {
  const { propertyId } = house

  const te = useTranslations('enquiry')
  const [url, setUrl] = useState()
  const [agent, setAgent] = useState()

  const { data } = useFetch(url)
  const { openDialog, closeDialog, Dialog } = useDialog()
  const agents = useMemo(() => (isArray(data?.agents) ? data.agents.slice(0, 3) : []), [data])

  const handleEnter = useCallback(() => {
    setUrl(`agent/property-promote-agents/${propertyId}`)
  }, [propertyId])

  // 免费获取估价
  const handleEstimateFreeButtonClick = useCallback((agt) => {
    setAgent(agt)
    openDialog()
  }, [openDialog])

  const handleClose = useCallback(() => {
    setAgent(null)
    closeDialog()
  }, [closeDialog])

  return (
    <>
      <Waypoint onEnter={handleEnter}>
        <div 
          className={clsx([
            'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4',
            'mt-8 border-t pt-6 md:pt-10',
            agents.length === 0 && 'hidden'
          ])}
        >
          {agents.map((item) => (
            <PromoteAgentCard 
              key={item.id} 
              data={item}
              onEstimateFreeButtonClick={() => handleEstimateFreeButtonClick(item)}
            />
          ))}
        </div>
      </Waypoint>
      {agent && (
        <Dialog title={te('mailConsultingAgency')}>
          <MailConsultingAgency 
            type="agent"
            agentId={agent.id}
            body="Hi，I’d like to get a free appraisal on …"
            onSuccess={handleClose}
            house={house}
          />
        </Dialog>
      )}
    </>
  )
}

PromoteAgents.propTypes = {
  propertyId: PropTypes.number,
}
